import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { GlobalContextInterface } from '../Types/core'
import { SESSION_STORAGE } from '../constants/sessionStorage'

type ContextStore = {
  globalContext: GlobalContextInterface
  setGlobalContext: (context: GlobalContextInterface) => void
}

export const useContextStore = create<ContextStore>()(
  devtools(
    (set) => ({
      globalContext: {
        protocol: '',
        username: '',
        environment: '',
        produtoid: '',
        nif: '',
        token: '',
      },
      setGlobalContext: (context: GlobalContextInterface) =>
        set(() => {
          sessionStorage.setItem(
            SESSION_STORAGE.globalContext,
            JSON.stringify(context),
          )

          return { globalContext: context }
        }),
    }),
    { name: 'ContextStore' },
  ),
)
